import { Component, EventEmitter, Output } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { AppService } from '../../services/app.service';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { AuthService } from '../../../shared/auth/auth.service';
import { NgIf } from '@angular/common';

@Component({
  selector: 'vex-floating-switch',
  standalone: true,
  imports: [MatIconModule, MatSlideToggleModule, NgIf],
  templateUrl: './floating-switch.component.html',
  styleUrl: './floating-switch.component.scss'
})
export class FloatingSwitchComponent {
  isActive = false;

  constructor(
    public appService: AppService,
    public authService: AuthService
  ) {}

  switchMode() {
    this.isActive = !this.isActive;
    this.appService.toggleEditMode();
  }
}
